.main {
  min-width: 0;
  outline: none;
}

.sidebar {
  display: none;
}

@media (min-width: 1100px) {
  .body:has(.sidebar) {
    --sidebar-width: 296px;
    display: grid;
    grid-template-columns: var(--sidebar-width) minmax(0, 1fr);
  }

  .sidebar {
    position: sticky;
    top: 52px;
    display: block;
    height: calc(100dvh - 52px);
    overflow-y: auto;
    padding: var(--space-3) var(--space-2) var(--space-6) max(var(--space-2), env(safe-area-inset-left));
    border-right: var(--hairline) solid var(--separator);
  }
}

.waiting {
  min-height: 100dvh;
}

.skip {
  position: fixed;
  top: var(--space-2);
  left: var(--space-2);
  z-index: 60;
  padding: var(--space-2) var(--space-3);
  border-radius: var(--radius-control);
  background: var(--ink);
  color: var(--on-ink);
  font: var(--text-subhead);
  text-decoration: none;
  transform: translateY(-200%);
}

.skip:focus {
  transform: none;
}
